if (!customElements.get('impact-showcase')) {
  customElements.define(
    'impact-showcase',
    class ImpactShowcase extends HTMLElement {
      constructor() {
        super();
        this.desktopSelect = this.querySelector('.impact-showcase-category-container');
        this.mobileDropDown = this.querySelector('.impact-showcase-mobile-dropdown');

        this.mobileCategoryTitle = this.querySelector('.impact-showcase-click-text-inner-text');
        this.categories = this.querySelectorAll('.impact-showcase-category');

        this.mobileDropdownItems = this.querySelector('.impact-showcase-category-container-mobile');
        this.mobileCategoriesWrapper = this.querySelector('.impact-showcase-category-mobile-inner');

        this.products = this.querySelectorAll('.impact-showcase-impact-card');
        this.dropdownButton = this.querySelector('.impact-showcase-mobile-click-text');
        this.isDropdownOpen = false;
      }

      connectedCallback() {
        const firstDesktopCategory = this.categories[0];
        const firstMobileCategory = this.categories[this.categories.length / 2];

        if (window.innerWidth < 990) {
          firstMobileCategory.classList.add('selected');
          this.mobileCategoryTitle.innerHTML = firstMobileCategory.dataset.title;
        } else {
          firstDesktopCategory.classList.add('selected');
        }

        this.categories.forEach((category) => {
          if (category.parentElement.classList.contains('impact-showcase-category-mobile-inner')) {
            category.classList.add('mobile');
          }
        });

        this.setDropdownFullHeight();
        this.dropdownButton.addEventListener('click', this.toggleDropdown.bind(this));

        [this.mobileCategoriesWrapper, this.desktopSelect].forEach((element) =>
          element.addEventListener('click', this.handleCategoryChange.bind(this))
        );

        this.debouncedResize = debounce(() => {
          this.handleResize();
        }, 250);

        window.addEventListener('resize', this.debouncedResize.bind(this));
        document.addEventListener('click', (e) => {
          if (!this.mobileDropDown.contains(e.target)) {
            this.closeDropdown();
          }
        });
      }

      setDropdownFullHeight() {
        this.dropdownFullHeight = this.mobileCategoriesWrapper.offsetHeight;
      }

      toggleDropdown(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }

        this.isDropdownOpen = !this.isDropdownOpen;
        this.mobileDropDown.classList.toggle('active', this.isDropdownOpen);

        this.mobileDropdownItems.style.height = this.isDropdownOpen ? `${this.dropdownFullHeight}px` : '0px';
      }

      closeDropdown() {
        if (this.isDropdownOpen) {
          this.isDropdownOpen = false;
          this.mobileDropDown.classList.remove('active');
          this.mobileDropdownItems.style.height = '0px';
        }
      }

      handleCategoryChange(event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.target == this.mobileCategoriesWrapper || event.target == this.desktopSelect) return;

        const category = event.target;

        const currentCategory = this.querySelector('.impact-showcase-category.selected');
        if (!category || (category.dataset.handle == currentCategory.dataset.handle && category == currentCategory))
          return;

        if (category.classList.contains('mobile')) {
          this.toggleDropdown(event);
          this.mobileCategoryTitle.innerHTML = category.dataset.title;
        }
        this.products.forEach((product) => {
          if (product.dataset.collectionHandle == category.dataset.handle) product.classList.add('active');
          else product.classList.remove('active');
        });

        currentCategory.classList.remove('selected');
        category.classList.add('selected');
      }

      handleResize() {
        const currentCategory = this.querySelector('.impact-showcase-category.selected');
        if (!currentCategory || currentCategory.checkVisibility()) return; // If the category is visible, no need to update

        let newSelect;
        const selectedHandle = currentCategory.dataset.handle;

        if (window.innerWidth < 990) {
          newSelect = this.mobileDropDown?.querySelector(`.impact-showcase-category[data-handle="${selectedHandle}"]`);
          if (newSelect && this.mobileDropDown) {
            this.setDropdownFullHeight();
            this.mobileCategoryTitle.innerHTML = newSelect.dataset.title;
          }
        } else {
          newSelect = this.querySelector(
            `.impact-showcase-category-container .impact-showcase-category[data-handle="${selectedHandle}"]`
          );
          this.closeDropdown();
        }

        if (!newSelect) return;

        currentCategory.classList.remove('selected');
        newSelect.classList.add('selected');

        if (window.innerWidth >= 990) {
          this.closeDropdown();
        }
      }

      disconnectedCallback() {
        if (this.mobileCategoriesWrapper)
          this.mobileCategoriesWrapper.removeEventListener('click', this.handleCategoryChange.bind(this));
        if (this.desktopSelect) this.desktopSelect.removeEventListener('click', this.handleCategoryChange.bind(this));
        if (this.debouncedResize) window.removeEventListener('resize', this.debouncedResize.bind(this));
        if (this.dropdownButton) this.dropdownButton.removeEventListener('click', this.toggleDropdown.bind(this));
        document.removeEventListener('click', (e) => {
          if (!this.mobileDropDown.contains(e.target)) {
            this.closeDropdown();
          }
        });
      }
    }
  );
}
